const iconJdImg = require('../images/common/icon-jd.png');
const iconKlImg = require('../images/common/icon-kl.png');
const iconYxImg = require('../images/common/icon-yx.png');
const iconZyImg = require('../images/common/icon-zy.png');
const iconTbImg = require('../images/common/icon-tb.png');
const iconTmImg = require('../images/common/icon-tm.jpg');
const iconqskImg = require('../assets/image/logo-qsk.png');
const iconpddImg = require('../images/common/icon-pdd.png');
const iconVipImg = require('../images/common/icon-vip.png');
const iconMinisoImg = require('../images/common/icon-miniso.png');
const iconSnImg = require('../images/common/icon-sn.png');

// 搜索页fends icon
const searchSnIcon = require('../images/result/tab/sn.png');
const searchJdIcon = require('../images/result/tab/jd.png');
const searchKlIcon = require('../images/result/tab/kl.png');
const searchKnightIcon = require('../images/result/tab/knight.png');
const searchMinisoIcon = require('../images/result/tab/miniso.png');
const searchPddIcon = require('../images/result/tab/pdd.png');
const searchTbIcon = require('../images/result/tab/tb.png');
const searchTmIcon = require('../images/result/tab/tm.png');
const searchVipIcon = require('../images/result/tab/vip.png');
// const searchYxIcon = require('../images/result/tab/yx.png');
const searchAllIcon = require('../images/result/tab/all.png');
const searchInletIcon = require('../images/result/tab/inlet.png');

// 供应商文案icon
const textTbImg = require('../images/common/supplier-text/text-taobao.png');
const textJdImg = require('../images/common/supplier-text/text-jingdong.png');
const textPddImg = require('../images/common/supplier-text/text-pingduoduo.png');
const textSnImg = require('../images/common/supplier-text/text-suning.png');
const textWphImg = require('../images/common/supplier-text/text-weipinhui.png');
const textKlImg = require('../images/common/supplier-text/text-kaolahaigou.png');

const iconCardJdImg = require('../images/common/supplier-card-icon/icon-jd.png');
const iconCardKlImg = require('../images/common/supplier-card-icon/icon-kl.png');
const iconCardYxImg = require('../images/common/supplier-card-icon/icon-yx.png');
const iconCardZyImg = require('../images/common/supplier-card-icon/icon-zy.png');
const iconCardTbImg = require('../images/common/supplier-card-icon/icon-tb.png');
const iconCardTmImg = require('../images/common/supplier-card-icon/icon-tm.png');
const iconCardqskImg = require('../images/common/supplier-card-icon/icon-zy.png');
const iconCardpddImg = require('../images/common/supplier-card-icon/icon-pdd.png');
const iconCardVipImg = require('../images/common/supplier-card-icon/icon-vip.png');
const iconCardMinisoImg = require('../images/common/supplier-card-icon/icon-miniso.png');
const iconCardSnImg = require('../images/common/supplier-card-icon/icon-sn.png');

// 供应商对应 id
export const SUPPLIER = {
    jd: 1, // 京东（商城入库）
    kl: 2, // 考拉（商城入库）
    yx: 3,
    ys: 3,
    knight: 4, // 商城(商城入库)
    tb: 5, // 淘宝(cps)
    tm: '5-1', // 天猫(cps)
    jdFan: 7, // 京粉(cps)
    jdFake: 15, // 京粉？(cps)
    jdpg: '7-1',
    zk: 10, // 考拉赚客(cps)
    qs: 'qs',
    pdd: 11, // 拼多多(cps)
    dqhdk: '12', // 抖券
    dqhdktm: '12-1', // 抖券
    vip: 14, // 唯品会(cps)
    miniso: 16, // 名创优品 (商城入库)
    sn: 21, // 苏宁自营（商城入库）
    sncps: 130, // CPS苏宁易购
    pptm: 22, // 品牌特卖(入库)
    knight_tm: 23, // 天猫(入库)
    inlet: 100, // 骑士国际、洋葱海淘(入库)
};
export const supplierName = {
    jd: '骑士优选',
    kl: '考拉',
    yx: '严选',
    knight: '骑士优选',
    tb: '淘宝',
    tm: '天猫',
    jdFan: '京东',
    jdpg: '京东',
    zk: '考拉',
    pdd: '拼多多',
    vip: '唯品会',
    miniso: '名创优品',
    sn: '苏宁',
    sncps: '苏宁',
    pptm: '唯品会', // 品牌特卖目前也只有唯品会
    knight_tm: '骑士优选',
    inlet: '骑士国际',
};
export const priceName = Object.keys(supplierName).reduce((p, key) => {
    p[key] = `${supplierName[key]}参考价`;
    return p;
}, {});

export const onlyPriceName = Object.keys(supplierName).reduce((p, key) => {
    p[key] = `${supplierName[key]}`;
    return p;
}, {});

export const supplierIcon = {
    jd: iconZyImg,
    kl: iconKlImg,
    yx: iconYxImg,
    knight: iconZyImg,
    tb: iconTbImg,
    tm: iconTmImg,
    jdFan: iconJdImg,
    jdpg: iconJdImg,
    zk: iconKlImg,
    qs: iconqskImg,
    pdd: iconpddImg,
    vip: iconVipImg,
    jdFake: iconJdImg,
    miniso: iconMinisoImg,
    sn: iconSnImg,
    sncps: iconSnImg,
    knight_tm: iconZyImg,
};

// 商品卡片供应商logo
export const SUPPLIER_CARD_ICON = {
    jd: iconCardZyImg,
    kl: iconCardKlImg,
    yx: iconCardYxImg,
    knight: iconCardZyImg,
    tb: iconCardTbImg,
    tm: iconCardTmImg,
    jdFan: iconCardJdImg,
    jdpg: iconCardJdImg,
    zk: iconCardKlImg,
    qs: iconCardqskImg,
    pdd: iconCardpddImg,
    vip: iconCardVipImg,
    jdFake: iconCardJdImg,
    miniso: iconCardMinisoImg,
    sn: iconCardSnImg,
    sncps: iconCardSnImg,
    pptm: iconCardVipImg,
};

export const SEARCH_TAB_ICON = {
    0: searchAllIcon,
    [SUPPLIER.jd]: searchJdIcon,
    [SUPPLIER.jdFan]: searchJdIcon,
    [SUPPLIER.jdFake]: searchJdIcon,
    [SUPPLIER.jdpg]: searchJdIcon,
    [SUPPLIER.kl]: searchKlIcon,
    [SUPPLIER.zk]: searchKlIcon,
    // [SUPPLIER.yx]: searchYxIcon,
    [SUPPLIER.knight]: searchKnightIcon,
    [SUPPLIER.qs]: searchKnightIcon,
    [SUPPLIER.tb]: searchTbIcon,
    [SUPPLIER.tm]: searchTmIcon,
    [SUPPLIER.pdd]: searchPddIcon,
    [SUPPLIER.vip]: searchVipIcon,
    [SUPPLIER.miniso]: searchMinisoIcon,
    [SUPPLIER.sn]: searchSnIcon,
    [SUPPLIER.sncps]: searchSnIcon,
    [SUPPLIER.inlet]: searchInletIcon,
};

// 供应商标题图片
export const SUPPLIER_TEXT_ICON = {
    [SUPPLIER.jd]: textJdImg,
    [SUPPLIER.jdFan]: textJdImg,
    [SUPPLIER.jdFake]: textJdImg,
    [SUPPLIER.jdpg]: textJdImg,
    [SUPPLIER.kl]: textKlImg,
    [SUPPLIER.zk]: textKlImg,
    [SUPPLIER.tb]: textTbImg,
    [SUPPLIER.tm]: textTbImg,
    [SUPPLIER.pdd]: textPddImg,
    [SUPPLIER.vip]: textWphImg,
    [SUPPLIER.sn]: textSnImg,
    [SUPPLIER.sncps]: textSnImg,
};

// 京粉运营热区位置
export const operationConf = {
    index: '1133649983384578665', // 京粉首页
    channel: '1478549983421560145', // 精粉精选商品频道页面
};

const cacheTime = 1000 * 60 * 60 * 24; // 一天
// const cacheTime = 1000 * 20; // 一分钟
export const SHOPPING_CART_CACHE_TIME = cacheTime;

export const CASH_BACK_LONG = '返现¥';
export const CASH_BACK_SHORT = '返现¥';
export const CASH_BOUNTY = '返现¥';

/**
 * 获取对应的瀑布流页面参数
 *
 * @date 2020-03-12
 * @export
 * @param {*} page
 * @returns 1-首页-精选推荐tab-商品推荐位，2-首页-淘宝精选tab-商品推荐位，101-我的-商品推荐位，102-商品详情页-商品推荐位，103-我的订单列表-待支付/待发货/待收货列表商品推荐位，104-支付完成页-商品推荐位，105-商城天猫首页，106-京东首页，107-考拉海购首页，108-骑士优选首页，109-网易严选首页，110-拼多多首页，111-京粉首页，112-赚客首页，113-全局搜索页-全部tab，114-淘宝天猫搜索页,115-京东搜索页，116-考拉海购搜索页，117-骑士优选搜索页118-网易严选搜索页，119-拼多多搜索页
 */
export const getWaterfallPageConfig = function(option) {
    let pageId;
    let useWaterfall = true;
    option.supplierId = parseInt(option.supplierId);
    if (option.page == 'index') {
        switch (parseInt(option.supplierId)) {
            case SUPPLIER['kl']:
                pageId = 107;
                break;
            case SUPPLIER['jd']:
                pageId = 106;
                break;
            case SUPPLIER['jdFake']:
                pageId = 106;
                break;
            case SUPPLIER['tb']:
                if (option.tbWaterfall) {
                    pageId = 105;
                } else {
                    pageId = null;
                    useWaterfall = false;
                }
                break;
            case SUPPLIER['knight']:
                pageId = 108;
                break;
            case SUPPLIER['yx']:
                pageId = 109;
                break;
            case SUPPLIER['pdd']:
                pageId = 110;
                break;
            case SUPPLIER['jdFan']:
                pageId = 111;
                break;
            case SUPPLIER['zk']:
                pageId = 112;
                break;
            case SUPPLIER['inlet']:
                pageId = 121;
                break;
        }
    }

    if (option.page == 'result') {
        switch (parseInt(option.supplierId)) {
            case 0:
                pageId = 113;
                break;
            case SUPPLIER['tb']:
                pageId = 114;
                break;
            case SUPPLIER['jd']:
                pageId = 115;
                break;
            case SUPPLIER['jdFake']:
                pageId = 115;
                break;
            case SUPPLIER['kl']:
                pageId = 116;
                break;
            case SUPPLIER['knight']:
                pageId = 117;
                break;
            case SUPPLIER['yx']:
                pageId = 118;
                break;
            case SUPPLIER['pdd']:
                pageId = 119;
                break;
            case SUPPLIER['inlet']:
                pageId = 122;
                break;
        }
    }

    // console.log('pageId: ', pageId);

    return {
        pageId,
        useWaterfall,
    };
};

export const PLATFORM = {
    tb: 10,
    jd: 20,
    pdd: 30,
    kl: 40,
    vip: 80,
    sn: 130,
};

export const PLATFORM_NAME = {
    tb: '淘宝',
    jd: '京东',
    pdd: '拼多多',
    kl: '考拉',
    vip: '唯品会',
    sn: '苏宁易购',
};

export const LUCKY_BAG_TYPE = {
    tb: 'TAO_BAO_BUYER',
    jd: 'JIN_DON',
    pdd: 'PDD',
    kl: 'KAO_LA',
    vip: 'WPH',
    sn: 'SU_NING',
};

export const SALE_ACTIVITY_TYPE = {
    NYRX: 'N元任选', // N元任选
    NJMZ: '满折', // N件M折
    NJLJ: '满减', // N件立减M元
};
